import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const RefundPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Refund Policy — FitMind AI';
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo.png" alt="FitMind AI" />
        </Link>
      </header>

      <main className="legal-main container">
        <div className="legal-content">
          <div className="legal-title-block">
            <span className="legal-tag">Refunds</span>
            <h1>Refund Policy</h1>
            <p className="legal-meta">Last updated: May 2, 2025</p>
          </div>

          <p className="legal-intro">
            We want you to be completely satisfied with FitMind AI Pro. If you are not happy
            with your purchase for any reason, we offer a straightforward refund policy outlined
            below.
          </p>

          <section className="legal-section">
            <h2>14-Day Money-Back Guarantee</h2>
            <p>
              If you are not satisfied with your FitMind AI Pro subscription, you may request
              a full refund within <strong>14 days</strong> of the initial purchase date.
              No questions asked.
            </p>
            <p>
              This applies to both the monthly ($9.99) and annual ($49.99) subscription plans.
            </p>
          </section>

          <section className="legal-section">
            <h2>How to Request a Refund</h2>
            <p>To request a refund, contact us by email:</p>
            <div className="legal-contact-box">
              <div><strong>FitMind AI Support</strong></div>
              <div>
                Email:{' '}
                <a href="mailto:fitmindai@gmail.com?subject=Refund%20Request">
                  fitmindai@gmail.com
                </a>
              </div>
              <div>Subject line: <strong>Refund Request</strong></div>
            </div>
            <p>
              Please include the email address used during checkout. We will process your
              refund within <strong>5 business days</strong> and confirm by email once complete.
            </p>
          </section>

          <section className="legal-section">
            <h2>What Happens After a Refund</h2>
            <p>
              Once a refund is processed, your Pro subscription will be cancelled and your
              account will revert to the free plan. You will retain access to all free
              features.
            </p>
            <p>
              Refunds are returned to the original payment method. Processing times may vary
              depending on your bank or card provider (typically 3–10 business days).
            </p>
          </section>

          <section className="legal-section">
            <h2>Renewals</h2>
            <p>
              Refunds for renewal charges (monthly or annual) are eligible if requested
              within <strong>7 days</strong> of the renewal date. We recommend cancelling
              your subscription before the renewal date if you do not wish to continue.
            </p>
            <p>
              You can cancel your subscription at any time from within the FitMind AI app
              or by contacting us at{' '}
              <a href="mailto:fitmindai@gmail.com">fitmindai@gmail.com</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>Exceptions</h2>
            <p>We reserve the right to decline refunds in cases of:</p>
            <ul>
              <li>Requests made after the eligible refund window</li>
              <li>Accounts found to be in violation of our Terms of Service</li>
              <li>Repeated refund requests from the same account</li>
            </ul>
            <p>
              If you believe your situation warrants an exception, please contact us and we
              will review it on a case-by-case basis.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact</h2>
            <p>For any questions about this policy, reach out to us directly:</p>
            <div className="legal-contact-box">
              <div><strong>FitMind AI</strong></div>
              <div>Email: <a href="mailto:fitmindai@gmail.com">fitmindai@gmail.com</a></div>
            </div>
          </section>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <Link to="/">← Back to FitMind AI</Link>
          <span>·</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span>·</span>
          <Link to="/terms">Terms of Service</Link>
          <span>·</span>
          <span>© {new Date().getFullYear()} FitMind AI</span>
        </div>
      </footer>
    </div>
  );
};

export default RefundPolicy;
